import React from 'react'
import {useHistory} from 'react-router-dom'

import {Box, Theme, Typography} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

import {RouteEnum, useRoutes} from '@progyny/routes'

type Article = {
  slug: string
  title: string
}
interface RelatedArticlesProps {
  topics: Article[]
  title: string
}

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    position: 'relative',
    minWidth: 150,
    cursor: 'pointer',
    display: 'flex',
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.other.brandColors.disabledGray,
    borderRadius: 8,
  },
  title: {
    padding: '12px 16px',
    alignSelf: 'center',
  },
}))

const RelatedArticles: React.ComponentType<RelatedArticlesProps> = ({
  topics,
  title,
}: RelatedArticlesProps) => {
  const {classes} = useStyles()
  const history = useHistory()
  const {getPath} = useRoutes()

  return (
    <>
      <Typography
        variant={'body1'}
        fontWeight={600}
        gutterBottom
        mt={{xs: 4, sm: 0}}
        mb={3}
      >
        {title}
      </Typography>
      <Box mt={1}>
        {topics.map((topic) => {
          return (
            <Box
              key={topic?.slug}
              role={'link'}
              onClick={() =>
                history.push(`${getPath(RouteEnum.ARTICLES)}/${topic.slug}`)
              }
              className={classes.container}
            >
              <Box className={classes.title}>
                <Typography variant={'subtitle1'}>{topic?.title}</Typography>
              </Box>
            </Box>
          )
        })}
      </Box>
    </>
  )
}

export default RelatedArticles
